import { ITranslation, ITranslationGroup } from '@d-id/types';
import { atom } from 'recoil';

export const createTranslationModalOpen = atom<boolean>({
    default: false,
    key: 'create-translation-modal-open',
});

export const translationVideosSearch = atom<string>({
    default: '',
    key: 'translations-video-search',
});

export const translationToDelete = atom<ITranslation | null>({
    key: 'translation-to-delete',
    default: null,
});

export const translationGroupToDelete = atom<ITranslationGroup | null>({
    key: 'translation-group-to-delete',
    default: null,
});

export const selectedTranslationGroup = atom<ITranslationGroup | null>({
    key: 'selected-translation-group',
    default: null,
});

export const selectedTranslations = atom({
    key: 'selected-translations',
    default: new Map<string, ITranslation>(),
});
